"use client";

import { useEffect, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

// Inner component that uses the hooks that need Suspense
function PageViewTrackerInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      // Get the full URL including search params
      const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');
      
      // Track page view in Google Analytics
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: url,
          page_title: document.title || pathname,
          page_location: window.location.href
        });
      }
    }
  }, [pathname, searchParams]);

  // This component doesn't render anything
  return null;
}

// Wrapper component with Suspense
export default function PageViewTracker() {
  return (
    <Suspense fallback={null}>
      <PageViewTrackerInner />
    </Suspense>
  );
} 